// src/utils/cookieUtils.js
import Cookies from 'js-cookie';

export const clearAllCookies = () => {
    // Get all cookies
    const allCookies = Cookies.get();

    // Remove each cookie with js-cookie
    Object.keys(allCookies).forEach(cookieName => {
        // Remove with default settings
        Cookies.remove(cookieName);

        // Remove with path specified
        Cookies.remove(cookieName, { path: '/' });

        // Remove for specific domains
        Cookies.remove(cookieName, { domain: 'ba.bigul.co' });
        Cookies.remove(cookieName, { domain: 'ba.bigul.app' });
        Cookies.remove(cookieName, { domain: '*.bigul.co' });
        Cookies.remove(cookieName, { domain: '*.bigul.app' });
        Cookies.remove(cookieName, { domain: 'localhost' });
        // Cookies.remove("_ga", { path: "/", domain: "*.bigul.co" });
        // Cookies.remove("_ga_DZQ03YWS0P", { path: "/", domain: "*.bigul.co" });
    });

    // Brute force approach for cookies that might be missed
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();

        // Set expiration date in the past
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
    }
    console.log('cookies cleared by me');

};